import {
  LearnersStudentsStudent,
  LearnersStudentsStudentProfile,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

type FormProps = {
  student: LearnersStudentsStudentProfile
  religions: Array<SelectOption<number>>
  races: Array<SelectOption<number>>
  languages: Array<SelectOption<number>>
  countries: Array<SelectOption<number>>
  subjects: Array<SelectOption<number>>
  student_attachments: {
    photo_id: AttachmentAttributes
    naplan_chart: AttachmentAttributes
  }
}

export type EditProps = FormProps

export const useFormProps = () => useProps<EditProps>()

export type ShowProps = {
  student: LearnersStudentsStudent
}
export const useShowProps = () => useProps<ShowProps>()
